import axios from 'axios'

const adminApiPrefix = '/cs415sc1s54cxc651x6vf51vx'

const request = axios.create({
  // baseURL: `${process.env.VUE_APP_API_BASE_URL || 'http://localhost:5000'}${adminApiPrefix}`,
  baseURL: `${process.env.VUE_APP_API_BASE_URL || 'https://cnm.pink'}${adminApiPrefix}`,
  timeout: 30000
})

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.error?.message || error.response?.data?.message || error.message || '请求失败'
    return Promise.reject(new Error(message))
  }
)

export default request

